import React from 'react';

export function MoneyBag({
  width = 50,
  fillColor = 'white',
  ariaLabel = 'Money bag icon',
}: {
  width?: number;
  fillColor?: string;
  ariaLabel?: string;
}) {
  return (
    <svg
      width={width}
      viewBox="0 0 39 50"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
      fill={fillColor}
    >
      <path d="M11.86 9.06c.46-.15.93-.31 1.48-.31h12.32c.55 0 1.02.08 1.4.31 2.19-1.95 3.75-3.98 3.9-6.72a.82.82 0 00-.38-.7c-8.9-4.69-15.06 2.5-21.53 0-.55-.23-1.1.16-1.1.78.16 2.66 1.64 4.61 3.9 6.64zM25.66 17.19c1.25 0 2.42-.63 3.12-1.49 6.16 5.63 9.9 15.55 9.9 22.43C38.69 49.05 29.65 50 19.5 50S.31 49.06.31 38.12c0-6.87 3.75-16.8 9.9-22.42a4 4 0 003.13 1.49h12.32zM9.36 31.4a10.3 10.3 0 1020.6 0 10.3 10.3 0 10-20.6 0zM25.66 10.31H13.34a2.43 2.43 0 00-2.42 2.42v.4c0 1.32 1.1 2.42 2.42 2.42h12.32c3.28.07 3.28-5.24 0-5.24z" />
      <path d="M23.09 35.6a3.4 3.4 0 01-1.74 1.04c-.3.08-.44.23-.43.52.02.3 0 .58 0 .87 0 .26-.14.4-.41.4-.33.02-.67.01-1 0-.29 0-.43-.15-.43-.42v-.63c-.01-.47-.03-.49-.5-.56a6.57 6.57 0 01-1.78-.48c-.44-.2-.48-.3-.36-.74l.3-.96c.12-.37.23-.42.59-.24.62.3 1.28.47 1.97.55.44.06.88.01 1.29-.16.77-.31.89-1.15.24-1.65-.22-.17-.47-.3-.74-.4-.67-.28-1.37-.5-2-.85-1.04-.58-1.7-1.38-1.62-2.56.09-1.34.89-2.17 2.2-2.61.53-.19.53-.18.54-.7v-.54c0-.4.08-.47.5-.48h.4c.9 0 .9 0 .9.84 0 .6 0 .6.63.7.48.07.95.2 1.4.39.24.1.33.26.26.5l-.34 1.1c-.12.34-.24.39-.58.23a4.68 4.68 0 00-2.22-.41c-.2 0-.4.03-.59.11-.66.28-.77.97-.2 1.4.28.21.61.37.96.5.59.23 1.19.46 1.75.75 1.79.93 2.27 3.04 1.01 4.48z" />
    </svg>
  );
}
